'use client';

import { c as _c } from "react/compiler-runtime";
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import Box from '@classify/react-core-components/Box';
import type { OfferData, OfferTopic } from '../types';
import ComparativeTable from './ComparativeTable';
import OffersDiplomaBanner from './OffersDiplomaBanner';
interface Props {
  topics: OfferTopic[];
  data: Record<'courses' | 'diploma', OfferData>;
}
export default function Page(t0) {
  const $ = _c(10);
  const {
    topics,
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      py: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ContentWrapper><Typography variant="h2" component="h1" sx={{
        textAlign: "center",
        mb: {
          xs: 2,
          sm: 4
        }
      }}>{translate("compare_offers.intro_sheet.title")}</Typography></ContentWrapper>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingInline: {
        xs: 0,
        sm: "unset"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data.courses || $[4] !== data.diploma || $[5] !== topics) {
    t4 = <Box component="section" sx={t1}>{t2}<ContentWrapper sx={t3}><ComparativeTable topics={topics} coursesData={data.courses} diplomaData={data.diploma} /></ContentWrapper></Box>;
    $[3] = data.courses;
    $[4] = data.diploma;
    $[5] = topics;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <OffersDiplomaBanner />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}